import React from "react";
import { Card } from "@shopify/polaris";
import { Row, Col, Progress } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import config from "../../config/config";
import { actFetchFilter } from "../../actions";

const TrackingStatus = () => {
  const dataStatistical = useSelector((state) => state.dataStatistical);
  const dataSettings = useSelector((state) => state.dataSettings);
  const dispatch = useDispatch();
  const history = useHistory();
  const path = config.pathName + "/orders?" + config.urlParamsValue;

  let showGraph = false;
  let dataAnalys = {
    success: 0,
    noTracking: 0,
    noTransaction: 0,
    invalidTrackingNumber: 0,
    invalidAccount: 0,
    overQuota: 0,
  };

  if (
    dataStatistical.order_paypal_stripe === 0 &&
    dataStatistical.order_submitted === 0 &&
    dataStatistical.all_order_fulfilled === 0
  ) {
    showGraph = false;
  } else {
    showGraph = true;
    dataAnalys = {
      success:
        Math.ceil(
          (dataStatistical.order_submitted /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      pending:
        Math.ceil(
          (dataStatistical.order_pending /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,

      noTracking:
        Math.ceil(
          (dataStatistical.order_no_tracking /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      noTransaction:
        Math.ceil(
          (dataStatistical.order_no_transaction_id /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      unconfirmAcc:
        Math.ceil(
          (dataStatistical.order_unconfirm_account /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      invalidTrackingNumber:
        Math.ceil(
          (dataStatistical.order_invalid_tracking_number /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      invalidAccount:
        Math.ceil(
          (dataStatistical.order_invalid_account /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
      overQuota:
        Math.ceil(
          (dataStatistical.order_over_plan /
            dataStatistical.order_paypal_stripe) *
            10000
        ) / 100,
    };
  }

  const handleIndicatorFilter = (filter) => {
    dispatch(actFetchFilter(filter));
    history.push(path);
  };
  return (
    <div>
      {showGraph === true && dataSettings.confirm_status === "1" ? (
        <Row>
          <Col xs="12" sm="12" md="12">
            <Card sectioned>
              <div className="statistical-layout">
                <div className="d-flex mt-3 mb-5">
                  {dataStatistical.order_submitted > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "1",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_submitted}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_submitted > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          Add tracking successfully
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.success}
                          color="success"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_pending > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "0",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_pending}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_pending > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          Pending
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.pending}
                          color="info"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_no_tracking > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "-1",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_no_tracking}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_no_tracking > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          No tracking code/cancelled
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.noTracking}
                          color="custom-1"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_invalid_tracking_number > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "5",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_invalid_tracking_number}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_invalid_tracking_number > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          Invalid Tracking Number
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.invalidTrackingNumber}
                          color="custom-2"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_invalid_account > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "6",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_invalid_account}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_invalid_account > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          Missing PayPal account
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.invalidAccount}
                          color="custom-3"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_no_transaction_id > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "4",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_no_transaction_id}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_no_transaction_id > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          No transaction id
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.noTransaction}
                          color="custom"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_unconfirm_account > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "3",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_unconfirm_account}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_unconfirm_account > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          No account or Invalid
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.unconfirmAcc}
                          color="custom-4"
                        />
                      </div>
                    </Card>
                  ) : null}
                  {dataStatistical.order_over_plan > 0 ? (
                    <Card>
                      <div
                        className="card-body"
                        onClick={() =>
                          handleIndicatorFilter({
                            payment: "paypal_stripe",
                            status: "2",
                            type: "filter",
                          })
                        }
                      >
                        <div className="h4 mb-1" style={{ fontSize: "22px" }}>
                          {dataStatistical.order_over_plan}{" "}
                          <small style={{ fontSize: "14px" }}>
                            {dataStatistical.order_over_plan > 1
                              ? "orders"
                              : "order"}
                          </small>
                        </div>
                        <small
                          style={{ fontSize: "14px" }}
                          className="text-muted font-weight-bold mb-3"
                        >
                          Over subscription plan
                        </small>
                        <Progress
                          className="progress-xs progress-white mt-3 mb-0"
                          value={dataAnalys.overQuota}
                          color="warning"
                        />
                      </div>
                    </Card>
                  ) : null}
                </div>
                <Progress multi>
                  {dataAnalys.success > 0 ? (
                    <Progress bar color="success" value={dataAnalys.success}>
                      {dataAnalys.success}%
                    </Progress>
                  ) : null}
                  {dataAnalys.pending > 0 ? (
                    <Progress bar color="info" value={dataAnalys.pending}>
                      {dataAnalys.pending}%
                    </Progress>
                  ) : null}
                  {dataAnalys.noTracking > 0 ? (
                    <Progress
                      bar
                      color="custom-1"
                      value={dataAnalys.noTracking}
                    >
                      {dataAnalys.noTracking}%
                    </Progress>
                  ) : null}
                  {dataAnalys.noTransaction > 0 ? (
                    <Progress
                      bar
                      color="custom"
                      value={dataAnalys.noTransaction}
                    >
                      {dataAnalys.noTransaction}%
                    </Progress>
                  ) : null}
                  {dataAnalys.invalidTrackingNumber > 0 ? (
                    <Progress
                      bar
                      color="custom-2"
                      value={dataAnalys.invalidTrackingNumber}
                    >
                      {dataAnalys.invalidTrackingNumber}%
                    </Progress>
                  ) : null}
                  {dataAnalys.invalidAccount > 0 ? (
                    <Progress
                      bar
                      color="custom-3"
                      value={dataAnalys.invalidAccount}
                    >
                      {dataAnalys.invalidAccount}%
                    </Progress>
                  ) : null}
                  {dataAnalys.unconfirmAcc > 0 ? (
                    <Progress
                      bar
                      color="custom-4"
                      value={dataAnalys.unconfirmAcc}
                    >
                      {dataAnalys.unconfirmAcc}%
                    </Progress>
                  ) : null}
                  {dataAnalys.overQuota > 0 ? (
                    <Progress bar color="warning" value={dataAnalys.overQuota}>
                      {dataAnalys.overQuota}%
                    </Progress>
                  ) : null}
                </Progress>
              </div>
            </Card>
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default TrackingStatus;
